<template>
    <div>
        <form-wizard shape="square" ref="step-wizard" @on-change="onChange" @on-complete="onComplete" color="#556ee6">
            <tab-content :lazy="true" :before-change="tabChange" v-for="view in step_data.spreadify_views" :key="view.id" :icon="`mdi mdi-numeric-${view.render_order}-box-multiple`">
                <div v-if="hasMounted">
                    <TableWrapper v-if="hasUID" @savedData="savedData" :uid="step_uid" />
                </div>
            </tab-content>
        </form-wizard>
        
    </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import { licenseAppState, licenseAppMethods } from '@/state/helpers'

import TableWrapper from '@/components/steps/spreadifyTableWrapper.vue';
export default {
    data:() => ({
        table: null,
        isLoading: true,
        hasMounted: false,
    }),
    components:{
        FormWizard, TabContent, TableWrapper
    },
    computed:{
        ...licenseAppState,
        step_uid(){
            let uid = '';
            if(this.$refs['step-wizard'] != undefined){
                let index = this.$refs['step-wizard'].activeTabIndex;
                uid = this.step_data.spreadify_views[index].spreadify_uid;
            }
            return uid;
        },
        hasUID(){
            if(this.step_uid == ''){
                return false;
            }
            else{
                return true;
            }
        }
    },
    methods:{
        ...licenseAppMethods,
        savedData(data){
            console.log('Returned Data', data);
        },

        /* Wizard methods */
        /* eslint-ignore-next-line */
        onChange(previous, next){
            console.log(previous + '->' + next);
        },
        onComplete(){
            alert('onComplete');
        },
        tabChange(){
            //TODO Add checks for ->
            //* - Save Empty fields prompt
            //* - Changes Made Prompt

            return true;
        }
        /* --- */
    },
    mounted(){
        this.$nextTick(()=>{
            this.hasMounted = true;
            this.$refs['step-wizard'].activateAll();
        })
    },
}
</script>

<style>

</style>